// Mesma regra do CustomerPermissionHelper.canAccessWebRoute da API: a empresa e os grupos ADMINISTRATOR têm acesso
// total; os demais grupos, só às rotas liberadas em ctg_permissions (o grupo vem junto do usuário no login).
export const hasFullAccess = (user) => user?.ctm_type === "CORPORATE" || (Boolean(user?.group?.ctg_active) && user?.group?.ctg_role === "ADMINISTRATOR");

export const canAccessRoute = (user, method, path) => {
    if (hasFullAccess(user)) return true;

    const permissions = user?.group?.ctg_active && Array.isArray(user.group.ctg_permissions) ? user.group.ctg_permissions : [];

    return permissions.some((permission) => permission?.path === path && String(permission?.method ?? "").toLowerCase() === method);
};

// Cada área do painel abre se o grupo tiver ao menos uma das rotas da API que a tela de entrada dela consome.
const AREA_ROUTES = {
    dashboard: [["post", "/dashboard"]],
    engajamento: [["post", "/dashboard/engagement"]],
    usuarios: [["post", "/customer/list"]],
    equipes: [["post", "/team/list"]],
    gruposDeUsuario: [["post", "/customer-group/list"]],
    pesquisas: [
        ["post", "/pesquisas/list"],
        ["post", "/pesquisas/dashboard"],
        ["post", "/pesquisas/relatorios/list"],
        ["get", "/pesquisas/modelos"],
    ],
    documentos: [["post", "/documents/list"]],
    planosDeAcao: [
        ["get", "/action-plan/list"],
        ["post", "/action-plan/dashboard"],
    ],
    empresa: [["get", "/customer-corporate/:id"]],
    dadosDePagamento: [["get", "/subscription/invoice"]],
};

export const canAccessArea = (user, area) => AREA_ROUTES[area]?.some(([method, path]) => canAccessRoute(user, method, path)) ?? false;

export const canAccessAnyArea = (user, areas = []) => areas.length === 0 || areas.some((area) => canAccessArea(user, area));
